export const convertToSlug = (txt) => {
    return txt
        ?.toLowerCase()
        .trim()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');
};

export const convertFromSlug = (slug) => {
    return slug?.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};
